import { FC } from "react";
import "./CuadreFP.css";
import { formatDecimals } from "../../../utils/utils";

interface InvoicesListProps {
  data: any;
  componentRef: any;
}

const CuadreFP: FC<InvoicesListProps> = ({ componentRef, data }) => {
  const Line = ({ label, value, red = false }: any) => (
    <div className={`ticket-row ${red ? "red" : ""}`}>
      <span className="ticket-label">{label}</span>
      <span className="ticket-dots"></span>
      <span className="ticket-value">{value}</span>
    </div>
  );

  return (
    <div className="ticket" ref={componentRef}>
      <div className="center bold">{data.company.Name}</div>
      <div className="center">{data.company.VAT_Registration_No}</div>
      <div className="center">{data.company.Address}</div>
      <div className="center">{data.company.City}</div>
      <div className="center">{data.company.Phone_No}</div>
      <div className="center">{data.company.E_Mail}</div>

      <br />

      <div className="center title">CUADRE POR FORMA DE PAGO</div>

      <div className="divider"></div>

      <div className="row">
        <span className="bold">TURNO #:</span>
        <span className="value">{data.turn}</span>
        <span className="value">{data.date}</span>
      </div>

      <br />

      <Line
        label="VENTAS"
        value={formatDecimals(data.subTotal + data.discount)}
      />
      <Line label="DESCUENTOS" value={formatDecimals(data.discount)} />
      <Line label="DEVOLUCIONES" value={formatDecimals(data.ret)} />
      <Line label="SUB-TOTAL" value={formatDecimals(data.subTotal)} />
      <Line label="IMPUESTOS" value={0.0} />
      <Line label="GIFTCARD" value={0.0} />
      <Line label="NETO" value={formatDecimals(data.subTotal)} />
      <Line label="APERTURA" value={formatDecimals(data.opening)} />

      <Line label="DEP. EFECTIVO" value={formatDecimals(data.cash)} red />

      <br />

      <div className="bold">GRUPO POS</div>

      <div
        className="table-header-1"
        style={{ marginTop: 3, borderBottom: "1px solid #555" }}
      >
        <span>Documento ID</span>
        <span>Denominacion</span>
        <span>Valor</span>
      </div>

      {(
        data.Grupos || [{ documentoId: 1, denominacion: "PESOS", valor: "$" }]
      ).map((g: any, i: any) => (
        <div key={i} className="table-row">
          <span>{g.documentoId}</span>
          <span style={{ textAlign: "right" }}>{g.denominacion}</span>
          <span>{g.valor}</span>
        </div>
      ))}

      <br />

      <div className="table-header-1">
        <span>Forma de pago</span>
        <span>Cobrado</span>
        <span>Digitado</span>
      </div>

      {(data.paymentForms || []).map((f: any, i: any) => (
        <div key={i} className="table-row">
          <span>{f.name}</span>
          <span style={{ textAlign: "right" }}>
            {formatDecimals(f?.charged)}
          </span>
          <span style={{ textAlign: "right" }}>
            {formatDecimals(f?.digitated || 0)}
          </span>
        </div>
      ))}

      <div className="divider">--------------------------------</div>

      <Line label="TOTAL" value={formatDecimals(data.subTotal)} />
    </div>
  );
};

export default CuadreFP;
